// extracted by mini-css-extract-plugin
module.exports = {"container":"_6ihNQOYx2AzQAsDizHZqX","heading":"lWU6QPXgrRvnwVYRD5Ssz","testimonials":"_3LfmN4ionr7JQutrqUW7zO"};